import { z } from "zod";

export const documentReviewSchema = z.object({});
export type DocumentReviewValues = z.infer<typeof documentReviewSchema>;
